var serverIp = 'https://contract.zhuyan.me/boot_new/boot'
export default  {
    serverIp:serverIp
}
